import { useEffect, useState } from 'react';
import QrCode from '../qr-code/QrCode';
import { H5, H4 } from '../../themes/typography';
import axiosServices from '../../utils/axios';
import Pagination from '../pagination/Pagination';

function TestQrCode() {
    const [data, setData] = useState(null);
    const examples = [
        {
            label: "Short Text",
            value: "Attendee Ticket",
        },
        {
            label: "Numeric Only",
            value: "12345678901234567890",
        },
        {
            label: "URL",
            value: "https://www.example.com",
        },
        {
            label: "Small JSON",
            value: { id: 1, ticketTypeId: 1, bookingId: 1001 },
        },
        {
            label: "Large JSON",
            value: {
                id: 1,
                eventId: 10,
                validFor: 30,
                ticketTypeId: 101,
                attendeeName: "John Doe",
                attendeeEmail: "john.doe@example.com",
                attendeePhone: "+1234567890",
            },
        },
        {
            label: "Long String",
            value: "A".repeat(120), // 120 characters
        },
    ];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosServices.get('/api/demo-qr');
                console.log('QR Code Examples from API:', response.data);
                setData(response?.data);
                // Handle the response data if needed
            } catch (error) {
                console.error('Error fetching QR code examples:', error);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="page-view">
            <div className="page-wrapper">

                <Pagination />

                {/* 
                <H4 style={{ marginBottom: "2rem" }}>
                    QR Code Data Variations
                </H4>
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                        gap: "2rem",
                    }}
                >
                    {examples.map((ex, idx) => (
                        <div
                            key={idx}
                            style={{
                                border: "1px solid var(--divider-color)",
                                borderRadius: "1rem",
                                padding: "1rem",
                                textAlign: "center",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "1rem",
                            }}
                        >
                            <H5>{idx + 1}. {' '}{ex.label}</H5>
                            <QrCode value={ex.value} />
                        </div>
                    ))}
                    <div
                        style={{
                            border: "1px solid var(--divider-color)",
                            borderRadius: "1rem",
                            padding: "1rem",
                            textAlign: "center",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "1rem",
                        }}
                    >
                        <H5>Backend Qr Code</H5>
                        <div
                            style={{
                                border: '5px solid var(--secondary-color)',
                                borderRadius: '1rem',
                                height: '200px',
                                width: '200px',
                                overflow: 'hidden',
                            }}
                        >
                            <img
                                src={data?.qr_code}
                                alt="Backend QR Code"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                            />
                        </div>
                    </div>
                </div>
                 */}

            </div>
        </div >
    );
}

export default TestQrCode;